export default {
    name: 'ShcTechnicalAnalysis',
    data() {
        return {
            showCopyToast: false,
            guideModal: null,
        };
    },
    mounted() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    methods: {
        async copyCode(code) {
            let copied = false;
            try {
                await navigator.clipboard.writeText(code);
                copied = true;
            } catch (e) {
                try {
                    const ta = document.createElement('textarea');
                    ta.value = code;
                    ta.style.position = 'fixed';
                    ta.style.left = '-9999px';
                    document.body.appendChild(ta);
                    ta.focus();
                    ta.select();
                    copied = document.execCommand('copy');
                    document.body.removeChild(ta);
                } catch (_) {
                    copied = false;
                }
            }
            if (copied) {
                this.showCopyToast = true;
                setTimeout(() => {
                    this.showCopyToast = false;
                }, 1800);
            }
        },
        openGuide(type) {
            const isPu = type === 'pu';
            this.guideModal = {
                src: isPu
                    ? 'https://songhancapital.com/assets/image/open_puprice.jpg'
                    : 'https://songhancapital.com/assets/image/open_vantage.jpg',
                caption: isPu
                    ? this.$t('blog.puPrime.guidePuCaption')
                    : this.$t('blog.puPrime.guideVantageCaption'),
            };
        },
        closeGuide() {
            this.guideModal = null;
        },
    },
};
